import format from 'date-fns/format';
import React from 'react';

import {
	isNumber,
	isString,
} from '~/utilities/typeCheck';



type Props = {
	datetime: Date | number | string,
};

const DateTime: React.FC<Props> = (props) => {
	const {
		datetime,
	} = props;

	let date: Date;

	if (isString(datetime) || isNumber(datetime)) {
		date = new Date(datetime);
	} else {
		date = datetime;
	}

	return (
		<>
			{format(date, 'd MMM yyyy, h:mm a')}
		</>
	);
};


export default DateTime;
